import { Dispatch, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../store/ApplicationState";
import { baseUrl } from "../constants/Config";
import { AllLogoutDispatchTypes } from "../models/DispatchTypes/Logout";
import { LogoutActionDispatchTypes } from "../constants/Logout";
import { Logout } from "../services/Logout";

export const LogoutOfApp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    AllLogoutDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: LogoutActionDispatchTypes.LOGOUT_INVOKE,
    });

    const response = await Logout(baseUrl);

    dispatch({
      response: response,
      type: LogoutActionDispatchTypes.LOGOUT_SUCCESS,
    });
  };
};